import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";

import { NOTIFICATIONS } from "~/constans/notifications";
import { TariffsService } from "~/entity/Tariffs/api/tariffsService";
import { IUpdateBaseTariffParams } from "~/entity/Tariffs/model/schema";
import { useAddNotificationMutation } from "~/schemas/generated/graphql";
import { defaultErrorHandlerFunc } from "~/shared/hooks/useRequestHandler";

interface UpdateTariffVariables {
  id: string;
  data: IUpdateBaseTariffParams;
}

export const useSaveBaseTariff = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const [addNotificationMutation] = useAddNotificationMutation({});

  const invalidateTariffs = () => {
    queryClient.invalidateQueries([TariffsService._routes.root]);
  };

  const notify = (content: string) => {
    addNotificationMutation({
      variables: { type: NOTIFICATIONS.success, content },
    });
  };

  const updateTariff = useMutation(
    ({ id, data }: UpdateTariffVariables) =>
      TariffsService.PUT.update(id, data),
    {
      onSuccess: () => {
        notify(t("tariffs.notification.updateSuccess"));
        invalidateTariffs();
      },
      onError: (e) => {
        defaultErrorHandlerFunc({ e, t, addNotificationMutation });
      },
    },
  );

  return { updateTariff };
};
